import LinkButton from '@stories/Components/Global/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import S from './RichText.styles';
import FormModal from '../FormModal/FormModal';
const RichText = (props) => {
    if (!props.content) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, null,
            React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }),
            props.cta && (React.createElement(LinkButton, { buttonType: "default", href: props.cta.url, target: props.cta.target }, props.cta.text)),
            props.formModal && (React.createElement(FormModal, { ...props.formModal })))));
};
export default RichText;
